/* global $ */

class MainMenuListItem {
  constructor($el) {
    this.$el = $el;
    this.$btn = this.$el.find('.MainMenuList__item-link');
    this.hasPulldown = this.$btn.hasClass('has-pulldown');

    if (this.hasPulldown) {
      this.isShowPulldown = false;
      this.$pulldown = this.$el.find('.Pulldown');
      this.$el.on('mouseover', () => {
        clearTimeout(this.outTimer);

        if (!this.isShowPulldown) {
          this.isShowPulldown = true;
          this.$pulldown
            .stop(false)
            .css({ opacity: 0, display: 'block' })
            .animate({ opacity: 1 }, 150, 'easeOutCubic');
        } else {
          this.$pulldown
            .stop(false)
            .animate({ opacity: 1 }, 150, 'easeOutCubic');
        }
      });
      this.$el.on('mouseout', () => {
        clearTimeout(this.outTimer);
        this.outTimer = setTimeout(() => {
          clearTimeout(this.outTimer);
          this.$pulldown
            .stop(false)
            .animate({ opacity: 0 }, 300, 'easeOutCubic', () => {
              this.$pulldown.css({ display: 'none' });
              this.isShowPulldown = false;
            });
        }, 200);
      });
    }
  }
}

class MainMenu {
  constructor() {
    this.$container = $('.MainMenu');
    this.$container.find('.MainMenuList__item').each((i, e) => {
      new MainMenuListItem($(e));
    });
  }
}

export default MainMenu;
